import * as React from 'react';

function SvgNetworkError(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" {...props}>
      <path d="M634.9 154.9C457.7-9 182.2-8.9 5.1 154.9c-6.7 6.2-6.8 16.6-.3 23l34.2 34c6.1 6.1 16 6.2 22.4.4 145.9-133.7 371.3-133.7 517.3 0 6.4 5.9 16.3 5.7 22.4-.4l34.2-34c6.4-6.4 6.3-16.9-.4-23zM320 352c-35.4 0-64 28.6-64 64s28.6 64 64 64 64-28.6 64-64-28.6-64-64-64zm202.7-83.6c-115.3-101.9-290.2-101.8-405.3 0-6.9 6.1-7.1 16.7-.6 23.1l34.4 34c6 5.9 15.7 6.3 22.1.8 83.9-72.6 209.7-72.4 293.5 0 6.4 5.5 16 5.1 22-.8l34.4-34c6.6-6.4 6.4-17-.5-23.1z" />
      <path fill="#fff" d="M217 4h203v339H217z" />
      <path d="M253.3 26.3l13.6 283.9c.6 13.3 11.2 23.8 24 23.8h66.3c12.8 0 23.3-10.5 24-23.8l13.6-283.9C395.4 12 384.5 0 370.8 0h-93.5c-13.8 0-24.7 12-24 26.3z" />
    </svg>
  );
}

export default SvgNetworkError;
